import React, { createContext, useContext, useState, useCallback } from 'react';
import OnboardingWizard from './components/OnboardingWizard';

const OnboardingContext = createContext(null);

export function OnboardingProvider({ children }) {
  const [open, setOpen] = useState(false);

  const openOnboarding = useCallback(() => setOpen(true), []);

  const closeOnboarding = useCallback(() => {
    localStorage.setItem('simbuilder-onboarding-seen', 'true');
    setOpen(false);
  }, []);

  return (
    <OnboardingContext.Provider value={{ openOnboarding, closeOnboarding }}>
      {children}
      {open && <OnboardingWizard onClose={closeOnboarding} />}
    </OnboardingContext.Provider>
  );
}

export function useOnboarding() {
  return useContext(OnboardingContext);
}
